module.exports = __webpack_public_path__ + "static/type-brigade-50-kisyuu-1-6a0bbd8dcfb040f3fb97c5975f1ae7ff.jpg";